export const SET_HOME_LINK = 'SET_HOME_LINK';

export function setHomeLink(link: string) {
  return {
    type: SET_HOME_LINK,
    link
  };
}
